import React, { FC, useEffect, useMemo, useState } from 'react';
import { Redirect, useHistory } from 'react-router-dom';

import { EvSpinner } from '@evinced-private/ui-common';

import { JiraApi } from '../../api/JiraApi';
import { FullPageError } from '../../components/full-page-error/FullPageError';
import { useUniversalLogin } from '../../hooks/useUniversalLogin';
import { logger } from '../../services/Logger';

import { JIRA_AUTHENTICATION_PAGE_LABELS } from './JiraAuthenticationPage.labels';

export const JiraAuthenticationPage: FC = () => {
	const history = useHistory();

	const search = useMemo(() => history?.location?.search, [history]);
	const { isAuthenticated } = useUniversalLogin();
	const [hasAuthenticationError, setHasAuthenticationError] = useState(false);

	useEffect(() => {
		const saveJiraToken = async (code: string): Promise<void> => {
			try {
				setHasAuthenticationError(false);
				await JiraApi.getAndSaveJiraToken(code);
			} catch (error) {
				logger.error('Failed to complete Jira authentication', error);
				setHasAuthenticationError(true);
			}
		};

		if (search) {
			const queryParams = new URLSearchParams(search);
			const code = queryParams.get('code');
			if (code) {
				saveJiraToken(code);
			}
		}
	}, [search]);

	if (!isAuthenticated()) {
		return <Redirect to="/login" />;
	}

	if (hasAuthenticationError) {
		return <FullPageError title={JIRA_AUTHENTICATION_PAGE_LABELS.authenticationErrorTitle} />;
	}

	return <EvSpinner />;
};
